// btw-front/src/components/sections/Results.jsx
import React, { useMemo } from "react";
import Container from "../ui/Container";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

export default function Results() {
  const { t } = useTranslation();
  const items = useMemo(() => t("results.items", { returnObjects: true }) || [], [t]);

  return (
    <section id="results" className="btw-section bg-slate-100">
      <Container>
        <Fade direction="up" triggerOnce>
          <div className="max-w-2xl">
            <span className="btw-eyebrow">{t("results.eyebrow")}</span>
            <h2 className="btw-h2 mt-4">{t("results.title")}</h2>
            <p className="btw-lead">{t("results.desc")}</p>
          </div>
        </Fade>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {items.map((it) => (
            <Fade key={it.title} direction="up" triggerOnce>
              <div className="btw-card-hover h-full p-6">
                <div className="text-lg font-semibold text-slate-900">{it.title}</div>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">{it.desc}</p>
              </div>
            </Fade>
          ))}
        </div>

        <div className="mt-8 text-xs text-slate-500">{t("results.note")}</div>
      </Container>
    </section>
  );
}
